import { Model } from './Model';

class CollectionReviewModel extends Model {
  get numberOfProducts() {
    return Number.parseInt(this.getNestedProperties(['metadata', 'productCount', 'allProducts'], '0'), 10);
  }

  get collectionName() {
    return this.getNestedProperties(['metadata', 'name'], '');
  }

  get collectionMetadata() {
    return this.getNestedProperties(['metadata'], {});
  }

  get collectionItems() {
    return this.getNestedProperties(['skus'], {});
  }
}

export { CollectionReviewModel };
